function cx(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export default cx;
